import { apiInfo, fetchRequest, HTTPMethod, Resource } from './api';

export const getTestimonials = () => {
    return fetchRequest(HTTPMethod.GET, `${apiInfo.base}/${Resource.TESTIMONIALS}`);
};
